<!--
    描述：系统通知
    时间：2021-05-17
    Created by 张磊
-->
<template>
	<div class="notification-layout filter-layout">
		<div class="filter-box">
			<el-row :gutter="15"
					v-show="searchToggle">
				<el-form ref="searchForm"
						 :model="searchForm"
						 label-width="100px"
						 size="small">
					<el-col :span="6">
						<el-form-item label="通知标题"
									  prop="sname">
							<el-input v-model="searchForm.sname"
									  placeholder="请输入通知标题"
									  clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="通知级别"
									  prop="level">
							<el-select v-model="searchForm.level"
									   placeholder="请选择通知级别"
									   clearable>
								<el-option :value="1"
										   label="一般"></el-option>
								<el-option :value="2"
										   label="重要"></el-option>
								<el-option :value="3"
										   label="紧急"></el-option>
							</el-select>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="发布人"
									  prop="publishName">
							<el-input v-model="searchForm.publishName"
									  placeholder="请输入发布人"
									  clearable></el-input>
						</el-form-item>
					</el-col>
					<el-col :span="6">
						<el-form-item label="发布时间">
							<el-date-picker v-model="searchForm.times"
											type="daterange"
											placeholder="请选择时间"
											format="yyyy-MM-dd"
											value-format="yyyy-MM-dd HH:mm:ss"
											@change="dealTime($event)"
											start-placeholder="开始日期"
											end-placeholder="结束日期"
											:default-time="['00:00:00', '23:59:59']"></el-date-picker>
						</el-form-item>
					</el-col>
					<el-col :span="24">
						<el-form-item class="text-right">
							<el-button type="primary"
									   class="btn-blue"
									   size="small"
									   icon="el-icon-search"
									   @click="doSearch">查询</el-button>
							<el-button size="small"
									   @click="doRefresh"
									   icon="el-icon-refresh">重置</el-button>
						</el-form-item>
					</el-col>
				</el-form>
			</el-row>

			<!-- 筛选折叠按钮 -->
			<div class="control-btn"
				 @click="searchToggle = !searchToggle">
				{{ searchToggle ? '点击收起' : '筛选' }}
				<svg-icon :icon-class="searchToggle ? 'pack-up' : 'pack-down'"
						  class="c-icon ml5"></svg-icon>
			</div>
		</div>
		<div class="filter-content primary-layout">
			<div class="primary-header">
				<div class="left-text">合计系统通知：{{ pageObj.total }} 条</div>
				<div class="btnGroups">
					<el-button type="primary"
							   size="small"
							   class="btn-blue"
							   v-if="roleBtns.includes('addNotice')"
							   @click="addNotice">新增通知公告</el-button>
					<el-button type="success"
							   size="small"
							   class="btn-success"
							   icon="el-icon-refresh"
							   @click="doRefresh"></el-button>
				</div>
			</div>
			<div class="primary-content"
				 v-loading="loading">
				<CustomTableVxe v-if="tableShow"
								:requestConfigUrl="CustomTableVxeData.requestConfigUrl"
								:requestDataUrl="CustomTableVxeData.requestDataUrl"
								:btnEvent="CustomTableVxeData.btnEvent"
								:config="CustomTableVxeData.table.config"
								:data="CustomTableVxeData.table.data"
								:page="CustomTableVxeData.table.page"
								@page-change="pageListen"
								class="xTable-notice">
					<template slot="通知级别"
							  slot-scope="scope">
						<span v-if="scope.row.level == 1"
							  style="color:#2C8CF0"
							  class="vxe-cell--label">一般</span>
						<span v-else-if="scope.row.level == 2"
							  style="color:#FF6600"
							  class="vxe-cell--label">重要</span>
						<span v-else-if="scope.row.level == 3"
							  style="color:#FF0000"
							  class="vxe-cell--label">紧急</span>
					</template>
					<template slot="状态"
							  slot-scope="scope">
						<vxe-switch v-model="scope.row.status"
									v-if="roleBtns.includes('status')"
									open-label="开启"
									:open-value="1"
									close-label="关闭"
									:close-value="0"
									disabled
									:class="{ opacityHide: scope.row.status == 0 }"
									@click.native.prevent="handleSwitch(scope.row)"></vxe-switch>
					</template>
				</CustomTableVxe>
			</div>
		</div>

		<!-- 通知弹窗 -->
		<el-dialog :title="msgObj.title"
				   :visible.sync="msgObj.show"
				   width="60%"
				   :close-on-click-modal="false"
				   center
				   top="5vh"
				   @close="doCancel">
			<NoticeDialog v-if="msgObj.show"
						  ref="notice"
						  :type="msgObj.type"
						  :acceptObj="selectObj"></NoticeDialog>
			<div slot="footer"
				 v-if="msgObj.type != 'view'">
				<el-button class="btn"
						   @click="doCancel">取 消</el-button>
				<el-button class="btn btn-success"
						   type="success"
						   :loading="btnLoading"
						   @click="doSubmit('save')">保 存</el-button>
				<el-button class="btn"
						   type="primary"
						   :loading="btnLoading"
						   @click="doSubmit('release')">发 布</el-button>
			</div>
		</el-dialog>
	</div>
</template>

<script>
import ConfigJson from './config.json'
import NoticeDialog from '@/views/NotificationManager/NoticeDialog'
import * as API from 'api/noticeManager/index'
import { mapState } from 'vuex'
export default {
	name: 'NotificationManager',
	components: { NoticeDialog },
	data() {
		return {
			// 搜索对象
			searchForm: {
				sname: '', // 通知标题
				level: '', // 级别
				publishName: '', // 发布人
				startDate: '', // 开始时间
				endDate: '', // 结束时间
				times: [],
			},
			searchToggle: true, //折叠控制
			// 自定义模板
			CustomTableVxeData: {
				requestConfigUrl: '',
				requestDataUrl: '',
				btnEvent: [
					{
						name: '查看',
						icon: '',
						renderIcon: 'form-look',
						show: (data) => {
							if (
								this.roleBtns.includes('viewNotice') &&
								data.status == 1
							) {
								return true
							}
							return false
						},
						disabled: (data) => {
							return false
						},
						click: (data) => {
							this.handleTool('view', data)
						},
					},
					{
						name: '编辑',
						icon: '',
						renderIcon: 'form-edit',
						show: (data) => {
							if (
								this.roleBtns.includes('editNotice') &&
								data.status == 0
							) {
								return true
							}
							return false
						},
						disabled: (data) => {
							return false
						},
						click: (data) => {
							this.handleTool('edit', data)
						},
					},
					{
						name: '发布',
						icon: '',
						renderIcon: 'form-shouli',
						show: (data) => {
							if (this.roleBtns.includes('status')) {
								return true
							}
							return false
						},
						disabled: (data) => {
							return !!data.status
						},
						click: (data) => {
							this.handleTool('fabu', data)
						},
					},
					{
						name: '浏览记录',
						icon: '',
						renderIcon: 'form-liulan',
						show: (data) => {
							if (this.roleBtns.includes('history')) {
								return true
							}
							return false
						},
						disabled: (data) => {
							return false
						},
						click: (data) => {
							this.handleTool('history', data)
						},
					},
					{
						name: '删除',
						icon: '',
						renderIcon: 'form-delete',
						show: (data) => {
							if (this.roleBtns.includes('deleteNotice')) {
								return true
							}
							return false
						},
						disabled: (data) => {
							return !!data.status
						},
						click: (data) => {
							this.handleTool('delete', data)
						},
					},
				],
				table: {
					config: {},
					page: {
						currentPage: 1,
						pageSize: 10,
						total: 0,
					},
					data: [],
				},
			},
			tableShow: true, //表格显示
			loading: false, //加载
			btnLoading: false, //按钮加载
			// 弹窗对象
			msgObj: {
				title: '', //标题
				show: false, //显隐
				type: '', //类型
			},
			// 通知对象
			msgForm: {
				test: '',
				test1: [],
				content: '',
			},
			selectObj: {}, //选中得编辑对象
			activeName: '1',
			pageObj: {
				size: 10,
				current: 1,
				total: 0,
			},
		}
	},
	created() {
		this.CustomTableVxeData.table.config =
			ConfigJson.NotificationManager.notification_manager
		this.getData()
	},
	methods: {
		// 获取系统通知数据
		getData() {
			this.loading = true
			this.tableShow = false
			let xTable = this.CustomTableVxeData.table
			let params = this.$utils.clone(this.searchForm)
			params.size = this.pageObj.size
			params.current = this.pageObj.current
			API.selectNoticeInfoByPage(params)
				.then((res) => {
					if (this.pageObj.size != -1) {
						xTable.page.total = parseInt(res.data.total)
						this.pageObj.total = parseInt(res.data.total)
					} else {
						xTable.page.total = parseInt(res.data.records.length)
						this.pageObj.total = parseInt(res.data.records.length)
					}
					setTimeout(() => {
						xTable.data = res.data.records
						this.loading = false
						this.tableShow = true
					}, 50)
				})
				.catch(() => {
					xTable.data = []
					xTable.page.total = 0
					this.loading = false
					this.tableShow = true
				})
		},

		// 分页监听
		pageListen(obj) {
			this.pageObj.current = obj.currentPage
			this.pageObj.size = obj.pageSize
			this.getData()
		},

		// 搜索
		doSearch() {
			this.pageObj.current = 1
			this.CustomTableVxeData.table.page.currentPage = 1
			this.getData()
		},

		// 重置
		doRefresh() {
			this.$refs.searchForm.resetFields()
			this.searchForm.times = []
			this.searchForm.startDate = ''
			this.searchForm.endDate = ''
			this.doSearch()
		},

		// 按钮点击事件
		handleTool(type, data) {
			this.selectObj = data
			switch (type) {
				case 'view':
					this.msgObj.show = true
					this.msgObj.title = '查看'
					this.msgObj.type = 'view'
					break
				case 'edit':
					this.msgObj.show = true
					this.msgObj.title = '编辑'
					this.msgObj.type = 'edit'
					break
				case 'history':
					// 储存当前菜单
					let obj = {
						meta: this.$route.meta,
						path: this.$route.path,
						name: this.$route.name,
					}
					this.$setSessionItem('activeMenu', JSON.stringify(obj))
					this.$router.push({
						name: 'BrowsingHistory',
						query: {
							type: 'BrowsingHistory',
						},
						params: {
							obj: data,
						},
					})
					break
				case 'delete':
					this.deleteMsg(data)
					break
				case 'fabu':
					this.handleSwitch(data)
					break
			}
		},

		// 新增系统通知
		addNotice() {
			this.msgObj.show = true
			this.msgObj.title = '新增'
			this.msgObj.type = 'add'
		},

		// 删除通知
		async deleteMsg(data) {
			let status = await this.$deleteConfirm('是否确认删除 ？', 1)
			if (status == 1) {
				this.loading = true
				API.delNoticeInfoById({
					id: data.id,
				})
					.then((res) => {
						this.getData()
					})
					.catch(() => {
						this.loading = false
					})
			} else {
				this.$message.info('操作取消！')
			}
		},

		// 弹窗提交按钮
		doSubmit(type) {
			let refs = this.$refs.notice
			refs.$refs.msgForm.validate((valid) => {
				if (valid) {
					this.btnLoading = true
					let params = this.$utils.clone(refs.msgForm)
					params.applyRole = params.applyRole.join(',')
					if (this.msgObj.type == 'add') {
						params.createUserid = this.userInfo.id
					}
					if (this.msgObj.type == 'edit') {
						params.updateUserid = this.userInfo.id
					}
					API.saveOrEditNoticeInfo(params)
						.then((res) => {
							if (type == 'save') {
								if (this.msgObj.type == 'add') {
									this.$message.success('保存完成！')
								}
								if (this.msgObj.type == 'edit') {
									this.$message.success('编辑完成！')
								}
							}
							refs.$refs.fileUpload.fileSend(res.data.id, '111', () => {
								this.btnLoading = false
								this.msgObj.show = false
								this.getData()
							},
							() => {
								this.btnLoading = false
								this.getData()
							})
							if (type == 'release') {
								this.handleSwitch(res.data, 'dialog')
								return
							}
						})
						.catch(() => {
							this.btnLoading = false
						})
				} else {
					this.$message.error('请完善表单！')
				}
			})
		},

		// 弹窗取消按钮
		doCancel() {
			this.msgObj.show = false
			this.selectObj = {}
			this.getData()
		},

		// 通知级别展示处理
		dealLevel(data) {
			let msg = ''
			switch (data) {
				case 1:
					msg = '一般'
					break
				case 2:
					msg = '重要'
					break
				case 3:
					msg = '紧急'
					break
			}
			return msg
		},

		// 处理时间
		dealTime(data) {
			if (data) {
				this.searchForm.startDate = data[0]
				this.searchForm.endDate = data[1]
			} else {
				this.searchForm.startDate = ''
				this.searchForm.endDate = ''
			}
		},

		// 发布
		async handleSwitch(data, type) {
			if (type == 'dialog') {
				this.sendMsg(data)
				return
			}
			let status = await this.$deleteConfirm('是否将通知发布？', true)
			if (status) {
				this.sendMsg(data)
			} else {
				this.$message.info('操作取消！')
			}
		},

		// 发布接口
		sendMsg(data) {
			this.loading = true
			this.btnLoading = true
			API.setNoticeStatus({
				id: data.id,
				status: 1,
			})
				.then((res) => {
					this.btnLoading = false
					this.msgObj.show = false
					this.getData()
				})
				.catch(() => {
					this.btnLoading = false
				})
		},
	},
	computed: {
		...mapState('user', {
			userInfo: (state) => state.userInfo,
		}),
		...mapState('menu', {
			roleBtns: (state) => state.roleBtns,
		}),
	},
}
</script>

<style scoped lang="less">
.notification-layout {
	padding: 30px 20px 5px 20px;
	.filter-box {
		padding-bottom: 15px;
	}
	.btn {
		padding: 0 50px !important;
		height: 40px;
	}
	.vxe-switch.is--disabled {
		opacity: 1;
		/deep/ .vxe-switch--button {
			cursor: pointer !important;
		}
	}
	/deep/ .is--on {
		.vxe-switch--button {
			background-color: #409eff !important;
		}
	}
	.xTable-notice {
		/deep/ .vxe-button + .vxe-button {
			margin: 0;
		}
		/deep/ .vxe-button {
			margin-right: 12px !important;
		}
	}
}
</style>
